import { memo } from "react";
import { motion } from "motion/react";
import { MediaRender } from "./MediaRender";
import type { ImageElement } from "./types";
import type { MediaAsset } from "pages/media/types";

interface AnimatedMediaRenderProps {
  imageElement: ImageElement;
  imageUrl: string;
  imageAsset: MediaAsset | undefined;
  isLoading: boolean;
  onAnimationComplete: () => void;
}

export const AnimatedMediaRender = memo(
  ({
    imageElement,
    imageUrl,
    imageAsset,
    isLoading,
    onAnimationComplete,
  }: AnimatedMediaRenderProps) => (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3, ease: "easeOut" }}
      onAnimationComplete={onAnimationComplete}
    >
      <MediaRender
        imageElement={imageElement}
        imageUrl={imageUrl}
        imageAsset={imageAsset}
        isLoading={isLoading}
      />
    </motion.div>
  )
);

AnimatedMediaRender.displayName = "AnimatedMediaRender";
